import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Form, Row, Button } from 'react-bootstrap';
import JobOffer from './JobOffer/JobOffer';
import CustomScroll from 'react-custom-scroll';
import "react-custom-scroll/dist/customScroll.css";
import Spinner from '../../UI/Spinner/Spinner';
import Auxiliary from '../../../hoc/Auxiliary';
import OfferTitle from './OfferTitle/OfferTitle';


const JobOffers = (props) => {
    const workspaceInfo = props.workspace
    const locationInfo = props.location
    const [displayJobsList, setDisplayJobsList] = useState(null);
    const [isLoading, setisLoading] = useState(true);
    const [error, seterror] = useState(null)
    const [allJobs, setallJobs] = useState(null);
    const [workspace, setWorkspace] = useState("");
    const [location, setLocation] = useState("");

    useEffect(() => {
        setJobsToDisplay(props.jobs)
        setallJobs(props.jobs)
    }, [props.jobs])

    useEffect(() => {
        if (props.error) {
            seterror(true)
            return;
        }
    }, [props.error])

    useEffect(() => {
        setJobsToDisplay(allJobs)
    }, [props.i18n.language])

    const search = e => {
        e.preventDefault();
        /* check what input is reciving values */
        if (e.target.id === "searchWork") {
            setWorkspace(e.target.value)
        } else if (e.target.id === "searchLocality") {
            setLocation(e.target.value)
        }

        if (allJobs !== null) {
            let icon = props.iconsFolder ? props.iconsFolder + '/location.svg' : ""
            let iconSrc = icon ? require('../../../assets/icons/' + icon) : "";
            let final = Object.keys(allJobs).filter((item) => {
                /* check if there is a job title */
                if (allJobs[item]["jobTitle"] && allJobs[item]["functionDescription"]) {
                    /* check if the location input is not empty and if there is a city name in allJobs value */
                    if (location !== "" && allJobs[item]["location"]) {
                        /* load content that only includes the location value */
                        if (location !== "" && workspace === ""
                            && allJobs[item]["location"].toLowerCase().includes(location.toLowerCase())) {
                            return allJobs
                        }
                        /* load content that includes both location and workspace values */
                        else if (workspace !== "" && location !== ""
                            && allJobs[item]["location"].toLowerCase().includes(location.toLowerCase())
                            && allJobs[item]["jobTitle"].toLowerCase().includes(workspace.toLowerCase())) {
                            return allJobs
                        }
                        else if (workspace !== "" && location !== ""
                            && allJobs[item]["jobTitle"].toLowerCase().includes(workspace.toLowerCase())
                            && location.toLowerCase() === "lisboa"
                            && (allJobs[item]["location"].toLowerCase() === "são jorge de arroios"
                                || allJobs[item]["location"].toLowerCase() === "lisboa")) {
                            return allJobs
                        }
                        else if (location !== "" && workspace === ""
                            && location.toLowerCase() === "lisboa"
                            && (allJobs[item]["location"].toLowerCase() === "são jorge de arroios"
                                || allJobs[item]["location"].toLowerCase() === "lisboa")) {
                            return allJobs
                        }
                    }
                    /* loads all content */
                    if (workspace === "" && location === "") {
                        return allJobs
                    }
                    /* loads content that icludes the workspace value */
                    else if (workspace !== "" && location === ""
                        && allJobs[item]["jobTitle"].toLowerCase().includes(workspace.toLowerCase())) {
                        return allJobs
                    }
                }
                /* if the element dont have jobTitle return false */
                else return false

            }).map((jobs, index) => {
                return (
                    <JobOffer
                        {...props}
                        key={index}
                        title={allJobs[jobs]["jobTitle"]}
                        icon={iconSrc}
                        location={allJobs[jobs]["location"]}
                        id={allJobs[jobs]['id']}
                    />
                )
            })
            setDisplayJobsList(final)
        }
    };

    const setJobsToDisplay = (jobs) => {
        if (jobs) {
            let icon = props.iconsFolder ? props.iconsFolder + '/location.svg' : ""
            let iconSrc = icon ? require('../../../assets/icons/' + icon) : "";
            seterror(false)
            setisLoading(false)
            let final = Object.keys(jobs).map((job, index) => {
                if (jobs[job]["jobTitle"] && jobs[job]["functionDescription"]) {
                    return (
                        <JobOffer
                            {...props}
                            key={index}
                            title={jobs[job]["jobTitle"]}
                            icon={iconSrc}
                            location={jobs[job]["location"]}
                            id={jobs[job]['id']}
                        />
                    )
                }
                else return false

            })
            setDisplayJobsList(final)
        }
    }
    return (
        <Auxiliary>
            {error ? "" : <Container fluid className='JobSearch p-0'>
                {/* mobile */}
                <Container className='content-jobSearch d-lg-none'>
                    <Row className='form-container gx-0'>

                        <Col xs={1} className='blue-cube'></Col>
                        <Col xs={11} className="d-flex flex-column align-items-center p-3">
                            <div className='d-flex flex-column justify-content-around p-0 w-95 h-100'>
                                <p className='title m-0 font-weight-900'>{workspaceInfo.title}</p>
                                <input id="searchWork" onKeyUp={(e) => search(e)} onInput={(e) => search(e)} placeholder={workspaceInfo.placeHolder} />
                            </div>
                        </Col>
                    </Row>
                    <Row className='form-container gx-0'>
                        <Col xs={1} className='blue-cube'></Col>
                        <Col xs={11} className="d-flex flex-column align-items-center p-3">
                            <div className='d-flex flex-column justify-content-around p-0 w-95 h-100'>
                                <p className='title m-0 font-weight-900'>{locationInfo.title}</p>
                                <input id="searchLocality" onKeyUp={(e) => search(e)} onInput={(e) => search(e)} placeholder={locationInfo.placeHolder} />
                            </div>
                        </Col>
                    </Row>
                    <Row className=' gx-0'>
                        <div className='d-flex align-items-center justify-content-center'>
                            <Button className='w-40' onClick={(e) => search(e)}>{props.t("jobs:section2.btnText")}</Button>
                        </div>
                    </Row>
                </Container>
                {/* desktop */}
                <Container className='content-jobSearch d-none d-lg-block'>
                    <Row className='form-container'>
                        <Col md={1} className='blue-cube'></Col>
                        <Col md={7} className="d-flex flex-column justify-content-around p-3">
                            <p className='title m-0 font-weight-900'>{workspaceInfo.title}</p>
                            <input id="searchWork" onKeyUp={(e) => search(e)} onInput={(e) => search(e)} placeholder={workspaceInfo.placeHolder} />
                        </Col>
                        <Col md={4} className="d-flex flex-column justify-content-around p-3">
                            <p className='title m-0 font-weight-900'>{locationInfo.title}</p>
                            <input id="searchLocality" onKeyUp={(e) => search(e)} onInput={(e) => search(e)} placeholder={locationInfo.placeHolder} />
                        </Col>
                    </Row>
                </Container>
            </Container>}
            <Container fluid className='JobOffers p-0'>
                {isLoading ? <div className='p-5 d-flex align-items-center justify-content-center'><Spinner /></div> : <Container className='content-jobOffers'>
                    <CustomScroll>
                        <Container className='scroll-container' >
                            {error ? <OfferTitle title={props.t('jobs:section3.errorOffers')} /> : displayJobsList && displayJobsList.length <= 0 ? <p className='noOffer font-weight-700'>{props.t("jobs:section3.job_content.infos.search")}</p> : displayJobsList}
                        </Container>
                    </CustomScroll>
                </Container>}
            </Container>
        </Auxiliary>
    )
}

const mapStateProps = state => {
    return ({
        jobs: state.jobs.jobs,
        error: state.jobs.error,
    });
}

export default connect(mapStateProps)(JobOffers)